import { AnimatePresence, motion } from 'motion/react';
import { CheckCircle } from 'lucide-react';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

interface OnboardingToastProps {
  message: string;
  isVisible: boolean;
}

export default function OnboardingToast({ message, isVisible }: OnboardingToastProps) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  return createPortal(
    <AnimatePresence>
      {isVisible && (
        <div className="pointer-events-none fixed inset-x-0 top-4 z-[100] flex justify-center px-4">
          <motion.div
            initial={{ opacity: 0, y: -12, scale: 0.96 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -12, scale: 0.96 }}
            transition={{ duration: 0.25, ease: 'easeOut' }}
            className="w-full max-w-sm"
            role="status"
            aria-live="polite"
          >
            <div className="flex items-center gap-3 rounded-xl bg-black/75 px-4 py-3 shadow-lg backdrop-blur-sm">
              <CheckCircle className="h-5 w-5 shrink-0 text-green-500" aria-hidden="true" />
              <p className="min-w-0 text-sm font-medium text-white">{message}</p>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>,
    document.body,
  );
}
